// Generated by CoffeeScript 1.9.1
var Model, Visibility;
Model = require("backbone-thin").Model;
module.exports = Visibility = Model.extend({
  defaults: {
    searchBox: -10,
    overviewBox: 30,
    headerBox: -1,
    alignmentBody: 0
  }
});